import api, {type ApiResponse} from "@/axios.js";
import {useServicesStore} from './services';
import {defineStore} from 'pinia'
import type {AxiosError} from "axios";

export interface WorkingTimeInterface {
    id: number;
    date: string;
    start: string;
    end: string;
    person_id: number|null
    date_human_text?: string
    person_name?: string
    option_id?: number
}

export const useWorkingTimeStore = defineStore('working_time', {
    state: () => ({
        _list: null as WorkingTimeInterface[] | null,
    }),
    getters: {
        list: (state) => state._list,

    },
        actions: {
            async load(): Promise<void> {
                try {
                    const response = await api.get<ApiResponse<WorkingTimeInterface[]>>('/working-time');
                    this._list = response.data.data;

                }
                catch (err: AxiosError | any) {
                    throw new Error(err.response?.data?.message || 'An error occurred');
                }
            },
            async destroy(id: number): Promise<void> {
                try {
                    await api.delete(`/working-time/${id}`);
                    useServicesStore()._full_list=null;
                    this._list = this._list?.filter(item => item.id !== id) as WorkingTimeInterface[];
                }
                catch (err: AxiosError | any) {
                    throw new Error(err.response?.data?.message || 'An error occurred');
                }
            },
            async update(request: WorkingTimeInterface) {
                try {
                    const response=await api.put(`/working-time/${request.id || 0}`, request);
                    const index = this._list?.findIndex(item => item.id === request.id);
                    if (index !== -1 && index !== undefined) {
                        this._list![index] = response.data.data;
                    } else {
                        this._list?.push(response.data.data);
                    }
                    useServicesStore()._full_list=null;
                    return response.data.data.id;
                }
                catch (err: AxiosError | any) {
                    throw new Error(err.response?.data?.message || 'An error occurred');
                }
            },
            async delete(request: WorkingTimeInterface) {
                try {
                      await api.delete(`/working-time/${request.id}`);
                    useServicesStore()._full_list=null;
                    this._list = this._list?.filter(item => item.id !== request.id) as WorkingTimeInterface[];
                } catch (err: AxiosError | any) {
                    throw new Error(err.response?.data?.message || 'An error occurred');
                }
            }
        }
})